<template>
  <div class="timer" :class="{ 'one-day-left': lessThanDay }">
    <span v-if="!lessThanDay" class="timer-part timer-days">
      <span class="timer__number">{{ days }} {{ trans("live.common.timer.days") }}</span>
    </span>
    <span v-if="hours > 0 && (!lessThanDay || lessThanDay)" class="timer-part timer-hours">
      <span class="timer__number">{{ hours }} {{ trans("live.common.timer.hours") }}</span>
    </span>
    <span v-if="(lessThanDay && minutes > 0) || (hours <= 0 && !lessThanDay)" class="timer-part timer-min">
      <span class="timer__number">{{ minutes }} {{ trans("live.common.timer.minutes") }}</span>
    </span>
    <span v-if="hours < 1 && lessThanDay" class="timer-part timer-sec">
      <span class="timer__number">{{ seconds }} {{ trans("live.common.timer.seconds") }}</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, watch, onMounted } from "vue";
import Timer from "easytimer.js";
import { trans } from '@/utils/trans';

const props = defineProps({
  dataDays: {
    type: Number,
    default: 0,
  },
  dataHours: {
    type: Number,
    default: 0,
  },
  dataMinutes: {
    type: Number,
    default: 0,
  },
  dataSeconds: {
    type: Number,
    default: 0,
  },
  dataCountdown: {
    type: Boolean,
    default: false,
  },
  isPaused: {
    type: Boolean,
    default: false,
  }
});

const timer = new Timer();

const days = ref(props.dataDays);
const hours = ref(0);
const minutes = ref(0);
const seconds = ref(0);

const lessThanDay = computed(() => days.value <= 0);

const updateTimer = () => {
  const values = timer.getTimeValues();
  days.value = values.days;
  hours.value = values.hours;
  minutes.value = values.minutes;
  seconds.value = values.seconds;
};

watch(
    () => props.isPaused,
    (isPaused) => {
      if (isPaused) {
        timer.pause();
      } else {
        timer.start();
      }
    }
);

onMounted(() => {
  timer.start({
    countdown: props.dataCountdown,
    startValues: {
      days: props.dataDays,
      hours: props.dataHours,
      minutes: props.dataMinutes,
      seconds: props.dataSeconds
    }
  });

  if (props.isPaused) {
    timer.pause();
  }

  updateTimer();

  timer.addEventListener('secondsUpdated', () => updateTimer());
});
</script>